import { BroadCastCreatePage } from './broadCast.create.page';

export default BroadCastCreatePage;
